// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lb4M","footer":"styles_footer__1Mlhx"};